const variableStates = {}
const variablePendingStates = {}
const variableActions = []

const variableList = [
  // 'account_type',
  'afscherming',
  'analyse_materiaal',
  'analyse_methode',
  'analyse_resultaat_hoeveelheid',
  'asbest_status',
  'asbestos_risk_assessment',
  'asbestos_survey_extend',
  'asbestos_survey_purpose',
  'asbestos_survey_scope',
  'asset_document_type',
  'behandeling_status',
  'behandelmoment',
  'beheersmaatregel_type',
  'bereikbaarheid',
  'beschadiging',
  'bevestiging',
  'binding',
  'blootstelling',
  'bron_advies',
  'bron_locatie_foto_label',
  'conditie',
  'document_type',
  'eenheid',
  'element_type',
  'inv_asset_document_type',
  'inventarisatie_rol',
  'language',
  'materiaal_type',
  'materiaal_status',
  'monster_soort',
  'onderzoek_soort',
  'onderzoek_status',
  'onderzoek_type',
  'organisatie_document_type',
  'product',
  'project_aard',
  'project_soort',
  'project_type',
  'ruimte_naam',
  'sanerings_advies',
  'smart_risicoklasse',
  'structuur',
  'toepassing',
  'beperking',
  'verdieping_naam',
  'waarneming_type',
  'svg_element_type',
  'vscp_check_procedure',
  'vscp_component',
  'vscp_material',
  'vscp_system',
  'vscp_zone',
  'inv_user_certificate_type',
  'inventarisatie_user_capability',
  'capability_cert_requirement',
  'uitrusting_type'
]
const pluralMap = {
  // 'account_type': 'account_types',
  afscherming: 'afschermingen',
  analyse_materiaal: 'analyse_materialen',
  analyse_methode: 'analyse_methodes',
  analyse_resultaat_hoeveelheid: 'analyse_resultaat_hoeveelheden',
  asbest_status: 'asbest_statussen',
  asbestos_risk_assessment: 'asbestos_risk_assessments',
  asbestos_survey_extend: 'asbestos_survey_extends',
  asbestos_survey_purpose: 'asbestos_survey_purposes',
  asbestos_survey_scope: 'asbestos_survey_scopes',
  asset_document_type: 'asset_document_types',
  behandeling_status: 'behandeling_statussen',
  behandelmoment: 'behandelmomenten',
  beheersmaatregel_type: 'beheersmaatregel_types',
  bereikbaarheid: 'bereikbaarheden',
  beschadiging: 'beschadigingen',
  bevestiging: 'bevestigingen',
  binding: 'bindingen',
  blootstelling: 'blootstellingen',
  bron_advies: 'bron_adviezen',
  bron_locatie_foto_label: 'bron_locatie_foto_labels',
  conditie: 'condities',
  document_type: 'document_types',
  eenheid: 'eenheden',
  element_type: 'element_types',
  inv_asset_document_type: 'inv_asset_document_types',
  inventarisatie_rol: 'inventarisatie_rollen',
  language: 'languages',
  materiaal_type: 'materiaal_types',
  materiaal_status: 'materiaal_statussen',
  monster_soort: 'monster_soorten',
  onderzoek_soort: 'onderzoek_soorten',
  onderzoek_status: 'onderzoek_statussen',
  onderzoek_type: 'onderzoek_types',
  organisatie_document_type: 'organisatie_document_types',
  product: 'producten',
  project_aard: 'project_aarden',
  project_soort: 'project_soorten',
  project_type: 'project_types',
  ruimte_naam: 'ruimte_namen',
  sanerings_advies: 'sanerings_adviezen',
  smart_risicoklasse: 'smart_risicoklasses',
  structuur: 'structuren',
  toepassing: 'toepassingen',
  beperking: 'beperkingen',
  verdieping_naam: 'verdieping_namen',
  waarneming_type: 'waarneming_types',
  svg_element_type: 'svg_element_types',
  vscp_check_procedure: 'vscp_check_procedures',
  vscp_component: 'vscp_components',
  vscp_material: 'vscp_materials',
  vscp_system: 'vscp_systems',
  vscp_zone: 'vscp_zones',
  inv_user_certificate_type: 'inv_user_certificate_types',
  inventarisatie_user_capability: 'inventarisatie_user_capabilities',
  capability_cert_requirement: 'capability_cert_requirements',
  uitrusting_type: 'uitrusting_types'
}
const pathMap = {
  // 'account_type': 'inventarisatie',
  afscherming: 'inventarisatie',
  analyse_materiaal: 'inventarisatie',
  analyse_methode: 'inventarisatie',
  analyse_resultaat_hoeveelheid: 'inventarisatie',
  asbest_status: 'inventarisatie',
  asbestos_risk_assessment: 'inventarisatie',
  asbestos_survey_extend: 'inventarisatie',
  asbestos_survey_purpose: 'inventarisatie',
  asbestos_survey_scope: 'inventarisatie',
  asset_document_type: 'inventarisatie',
  behandeling_status: 'inventarisatie',
  behandelmoment: 'inventarisatie',
  beheersmaatregel_type: 'inventarisatie',
  bereikbaarheid: 'inventarisatie',
  beschadiging: 'inventarisatie',
  bevestiging: 'inventarisatie',
  binding: 'inventarisatie',
  blootstelling: 'inventarisatie',
  bron_advies: 'inventarisatie',
  bron_locatie_foto_label: 'inventarisatie',
  conditie: 'inventarisatie',
  document_type: 'inventarisatie',
  eenheid: 'inventarisatie',
  element_type: 'inventarisatie',
  inv_asset_document_type: 'inventarisatie',
  inventarisatie_rol: 'inventarisatie',
  language: 'inventarisatie',
  materiaal_type: 'inventarisatie',
  materiaal_status: 'inventarisatie',
  monster_soort: 'inventarisatie',
  onderzoek_soort: 'inventarisatie',
  onderzoek_status: 'inventarisatie',
  onderzoek_type: 'inventarisatie',
  organisatie_document_type: 'inventarisatie',
  product: 'inventarisatie',
  project_aard: 'inventarisatie',
  project_soort: 'inventarisatie',
  project_type: 'inventarisatie',
  ruimte_naam: 'vastgoed',
  sanerings_advies: 'inventarisatie',
  smart_risicoklasse: 'inventarisatie',
  structuur: 'inventarisatie',
  toepassing: 'inventarisatie',
  beperking: 'inventarisatie',
  verdieping_naam: 'vastgoed',
  waarneming_type: 'inventarisatie',
  svg_element_type: 'inventarisatie',
  vscp_check_procedure: 'inventarisatie',
  vscp_component: 'inventarisatie',
  vscp_material: 'inventarisatie',
  vscp_system: 'inventarisatie',
  vscp_zone: 'inventarisatie',
  inv_user_certificate_type: 'inventarisatie',
  inventarisatie_user_capability: 'inventarisatie',
  capability_cert_requirement: 'inventarisatie',
  uitrusting_type: 'inventarisatie'
}
const excludeVariables = [
  'monster_soort',
  'analyse_methode',
  'analyse_materiaal',
  'analyse_resultaat_hoeveelheid',
  'materiaal_status',
  'capability_cert_requirement'
]

for (const variableType in pluralMap) {
  if (Object.prototype.hasOwnProperty.call(pluralMap, variableType)) {
    variableStates[pluralMap[variableType]] = state => state.variables[pluralMap[variableType]]
    variablePendingStates[`${pluralMap[variableType]}_pending`] = state => state.variables.pending[pluralMap[variableType]]
    variableActions.push('GET_' + pluralMap[variableType].toUpperCase())
    variableActions.push('GET_ONE_' + pluralMap[variableType].toUpperCase())
    variableActions.push('CREATE_' + pluralMap[variableType].toUpperCase())
    variableActions.push('UPDATE_' + pluralMap[variableType].toUpperCase())
    variableActions.push('DELETE_' + pluralMap[variableType].toUpperCase())
  }
}

export default {
  variableActions,
  variableStates,
  variablePendingStates,
  excludeVariables,
  variableList,
  pluralMap,
  pathMap
}
